const doc = [({"zh_cn":({"adminConstantHotelPlanBookingStatus":({"booked":"预订确认通知", "requested":"预约申请"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;